import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { API, AuthContext } from "../App";
import Layout from "../components/Layout";
import InsightsPanel from "../components/InsightsPanel";

const MONTHS = ["", "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];

function Dashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { user } = useContext(AuthContext);

  useEffect(() => {
    // Only fetched for the header line (month/year/days_left). Insights
    // Panel does its own data fetching independently.
    const fetchDashboard = async () => {
      try { setData((await axios.get(`${API}/dashboard/stats`)).data); }
      catch { /* non-fatal */ }
      finally { setLoading(false); }
    };
    fetchDashboard();
  }, []);

  if (loading) return <Layout><div className="p-8 text-[#64748B]">Loading...</div></Layout>;

  const daysLeft = data?.days_left || 1;

  return (
    <Layout>
      <div className="p-3 sm:p-6 space-y-4 sm:space-y-6" data-testid="dashboard-page">
        <div>
          <h1 className="text-xl sm:text-2xl font-black tracking-tight text-[#0F172A]" style={{ fontFamily: 'Chivo' }}>
            Dashboard
          </h1>
          <p className="text-xs sm:text-sm text-[#64748B] mt-1">
            {MONTHS[data?.month || 0]} {data?.year} &mdash; {daysLeft} days remaining &mdash; Welcome, {user?.username}
          </p>
        </div>

        {/* ── Insights Panel — the entire dashboard surface ───────────── */}
        <InsightsPanel />
      </div>
    </Layout>
  );
}

export default Dashboard;
